import { initNetworkAction } from "@nerdjs/nerd-network";
import { ReactElement, useEffect, useState } from "react";
import { AppConfig } from "./environement";
import { BookletPage } from "./routes/booklet";
import { useDispatch } from "react-redux";
import { Box, CircularProgress } from "@mui/joy";

/**
 * App wrapper
 *
 * @returns {ReactElement} App wrapper
 */
export default function NerdApp(): ReactElement {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(initNetworkAction(AppConfig.api));
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  return loading ? (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <BookletPage />
  );
}
